module.exports = __webpack_public_path__ + "static/media/bg.f2a74ec5.jpg";